<template>
    <div class="operation_guide">
        <div class="search">
            <div>
                <div class="hospital">
                    房间名称：
                    <Input v-model="roomName" placeholder="请输入" style="width:200px" clearable />
                </div>
                <div class="status">
                    状态：
                    <Select v-model="status" style="width:100px" clearable>
                        <Option value="true">在线</Option>
                        <Option value="false">离线</Option>
                    </Select>
                </div>
            </div>
            <Button type="primary" @click="search">查询</Button>
        </div>
        <Divider />
        <div class="box">
            <Row>
                <Col span="8" v-for="(item,index) in meetingList" :key="index">
                    <Card>
                        <div class="content">
                            <img src="../assets/meetingLogo.png" alt="">
                            <div>
                                <div class="title" :title="item.RoomName">{{item.RoomName}}</div>
                                <div class="room">房间ID：{{item.RoomID}}</div>
                            </div>
                        </div>
                        <Button class="footer" @click="joinMeeting(item.RoomID,item.UserJid)" :style="{color:item.Online == 'true' ? '#1890FF' : '#88949F'}" :disabled="item.Online == 'false'">{{item.Online == 'true' ? '加入手术' : '无法加入'}}</Button>
                        <span class="online" :style="{color:item.Online == 'true' ? '#00CC00' : '#88949F'}">
                            <Badge :color="item.Online == 'true' ? '#00CC00' : '#88949F'" />{{item.Online == 'true' ? '在线' : '离线'}}
                        </span>
                    </Card>
                </Col>
            </Row>
        </div>
        <div class="pagination">
            <Page :total="pageTotal" show-sizer show-elevator show-total :current="page" :page-size="pageSize"
                :page-size-opts="pageSizeOpts" @on-change="pageChange" @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>

<script>
import { Button,Input,Divider,Select,Option,Card,Badge,Row,Col,Page } from 'view-design'
import Request from "../utils/request"
import Config from "../config/index"
import Base64 from "base-64"
export default {
    components: { 
        Button,Input,Divider,Select,Option,Card,Badge,Row,Col,Page 
    },
    data() {
        return {
            roomName:'',
            status:'',
            pageSizeOpts:[9,18,27,36,45],
            pageTotal:0,
            page:1,
            pageSize:9,
            meetingList:[],
            centerID:JSON.parse(localStorage.getItem('Role')).CenterID,
            docType:JSON.parse(localStorage.getItem('Role')).DocType,
            roleID:JSON.parse(localStorage.getItem('Role')).RoleID,
            userJid:JSON.parse(localStorage.getItem('Role')).UserJid,
            hospitalName:JSON.parse(localStorage.getItem('Role')).HospitalName
        };
    },
    methods: {
        pageChange(page){
            this.page = page
            this.getListData()
        },
        pageSizeChange(pagesize){
            this.pageSize = pagesize
            this.getListData()
        },
        //获取页面数据
        getListData(){
            Request.getRequest(Config.SXG_baseUrl + '/api/casemanager/GetTeleconference',{
                Online:this.status ? this.status : '',
                RoomName:this.roomName,
                pageSize:this.pageSize,
                pageNum:this.page,
                UserJid:this.roleID == 3 ? '' : this.userJid
            }).then(res=>{
                console.log(res)
                if(res.code == 200){
                    this.meetingList = res.data.Record
                    this.pageTotal = res.data.count
                }else{
                    this.$Message.info(res.message)
                }
            })
        },
        //查询
        search(){
            console.log(this.roomName,this.status)
            this.page = 1
            this.getListData()
        },
        //加入会议
        joinMeeting(roomid,UserJid){
            let userjid = JSON.parse(localStorage.getItem('Role')).UserJid
            let username = JSON.parse(localStorage.getItem('Role')).DocName
            let medCareMessage = Base64.encode(`MedCareMessage_{"Type":"EnterYunWuRoom","RoomId":"${roomid}","RoomPwd":"","IsMyCreate":"${UserJid}"}`)
            window.location.href = `anymedwan://MedLink_{'From':'SurgeryPlatform','BizType':'Integrate','Action':'JoinMetting','Args':[{'UserJid':'${userjid}','UserName':'${username}','MettingID':'${roomid}','HostUserJid':'${UserJid}','SendMessageContent':'${medCareMessage}'}]}`
        }
    },
    created() {
        this.$emit("funChangeTitle", "远程手术指导", "6");
    },
    mounted(){
        this.getListData()
    }
}
</script>
<style lang='less'>
    .operation_guide{
        padding:20px;
        .search{
            display: flex;
            justify-content: space-between;
            &>div{
                display: flex;
                .hospital{
                    margin:0 30px 0 15px;
                }
            }
        }
        .ivu-divider-horizontal{
            margin-top:20px;
        }
        .box{
            .ivu-col{
                display: flex;
                justify-content: center;
                margin-bottom:30px;
            }
            .ivu-card{
                overflow: hidden;
                width:90%;
                padding:0;
                height:160px;
                position: relative;
                .ivu-card-body{
                    padding: 0;
                }
                .content{
                    box-sizing: border-box;
                    height: 109px;
                    display: flex;
                    padding:20px 0 0 20px;
                    img{
                        margin-right: 15px;
                        width:50px;
                        height:50px;
                    }
                    &>div{
                        flex-grow: 1;
                        overflow: hidden;
                    }
                    .title{
                        font-size: 16px;
                        font-weight: 700;
                        color:#000;
                        width:90%;
                        line-height:50px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .room{
                        color:#8F8F8F;
                    }
                }
                .footer{
                    border:0;
                    border-radius: 0;
                    width:100%;
                    height: 49px;
                    border-top:1px solid #E9E9E9;
                    background: #F7F9FA;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color:#1890FF;
                    font-size: 16px;
                    box-shadow:none;
                }
                .online{
                    position: absolute;
                    right:10px;
                    top:10px;
                    .ivu-badge-status-dot{
                        width:10px;
                        height:10px;
                    }
                }
            }
        }
        .pagination{
            position: fixed;
            bottom:40px;
            right:30px;
        }
    }
</style>